/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class UserProfileEvents {
}
UserProfileEvents.USER_PROFILE_SHOW = 'dell.sirius.user-profile.show';
UserProfileEvents.USER_PROFILE_UPDATED = 'dell.sirius.user-profile.updated';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci1wcm9maWxlLWV2ZW50cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zaGFyZWQvdXNlci1wcm9maWxlL2V2ZW50cy91c2VyLXByb2ZpbGUtZXZlbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxPQUFPLGlCQUFpQjs7QUFDSCxtQ0FBaUIsR0FBRywrQkFBK0IsQ0FBQztBQUNwRCxzQ0FBb0IsR0FBRyxrQ0FBa0MsQ0FBQyJ9